import React, { useState } from "react";
import { api, formatError } from "../lib/api";
import { useRazorpay, loadRazorpayScript } from "../lib/razorpay";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Zap } from "lucide-react";

export default function AutopayPanel({ plan, token, onChange }) {
  const rzp = useRazorpay();
  const [busy, setBusy] = useState(false);
  const status = plan.autopay_status;
  const usable = ["active", "grace"].includes(plan.state) && plan.auto_renew;

  const start = async () => {
    setBusy(true);
    try {
      await loadRazorpayScript();
      const { data } = await api.post(`/renewals/${token}/autopay`);
      const r = new window.Razorpay({
        key: data.key_id, subscription_id: data.subscription_id, name: data.name, description: data.description,
        prefill: data.prefill, theme: { color: "#4A0E17" },
        handler: async (res) => {
          try { onChange((await api.post(`/renewals/${token}/autopay/verify`, res)).data); toast.success("Auto-pay is on"); }
          catch (e) { toast.error(formatError(e)); }
        },
        modal: { ondismiss: () => setBusy(false) },
      });
      r.open();
    } catch (e) { toast.error(formatError(e)); }
    setBusy(false);
  };
  const stop = async () => {
    try { onChange((await api.post(`/renewals/${token}/autopay/cancel`)).data); toast.success("Auto-pay turned off"); }
    catch (e) { toast.error(formatError(e)); }
  };

  return (
    <div data-testid="autopay-panel" className="mt-6 rounded-2xl border border-[#D4AF37]/40 bg-white p-5">
      <div className="flex items-center gap-2"><Zap className="w-4 h-4 text-[#E65100]" /><span className="font-semibold text-[#4A0E17]">Auto-pay by UPI or card (India)</span></div>
      {status === "active" ? (
        <div className="mt-2 flex flex-wrap items-center gap-3">
          <span data-testid="autopay-on" className="text-sm text-green-800">On — about ₹{plan.price_inr.toLocaleString()} is charged automatically on {plan.expiry}.</span>
          <button data-testid="autopay-off-btn" onClick={stop} className="text-sm text-red-700 underline">Turn off</button>
        </div>
      ) : (
        <>
          {status === "halted" && <p data-testid="autopay-halted" className="mt-2 text-sm text-red-700">Your last auto-pay charge failed. Set it up again or renew once below.</p>}
          <p className="text-sm text-[#63534E] mt-2">Approve a UPI Autopay or card mandate once and your plan renews itself (about ₹{plan.price_inr.toLocaleString()} per {plan.period}).</p>
          <Button data-testid="autopay-start-btn" disabled={!rzp.enabled || !usable || busy} onClick={start} variant="outline" className="mt-3 rounded-full">
            {!rzp.enabled ? "Auto-pay · coming soon" : busy ? "Opening Razorpay…" : "Turn on auto-pay"}
          </Button>
        </>
      )}
    </div>
  );
}
